import React from 'react';
import ReactDOM from 'react-dom/client';
import {Box, Button, Container, HStack} from "@chakra-ui/react";
import {BrowserRouter as Router, Link, Navigate, Route, Routes, useLocation} from 'react-router-dom';

import AppLoginSuccess from "./AppLoginSuccess";

import {SignupForm} from './UserManagement/SignUp';
import {SignInForm} from './UserManagement/SignIn';
import {AccountDetails} from './UserManagement/Account';
import {VerificationSuccess} from './UserManagement/VerificationSuccess';
import {EmailVerificationNeeded} from './UserManagement/EmailVerificationNeeded';
import ApiKeysManagement from './APIKeyManagement/ApiKeysManagement';
import LLMModelManagement from './LLMModelManagement/LLMModelManagement';
import {AuthProvider, useAuth} from './UserManagement/authprovider';
import {ProtectedRoute} from './UserManagement/ProtectedRoute';
import Homepage from "./Homepage/Homepage";

import {MainLayout} from "./MainLayout/MainLayout";

import {PostHogProvider} from 'posthog-js/react';
import {Provider} from './Components/ui/provider';
import {ProxyExample} from './ProxyExample';

const postHogAPIKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const postHogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
console.log("Env KEY:", postHogAPIKey);
console.log("Env HOST:", postHogHost);

const options = {
    api_host: {postHogHost}
};

const App: React.FC = () => {
    return (
        <AuthProvider>
            <Routes>
                <Route path="/" element={<MainLayout/>}>
                    {/* Public routes */}
                    <Route index element={<Homepage/>}/>
                    <Route path="/signin" element={<SignInForm successPath="/account"/>}/>
                    <Route path="/signup" element={<SignupForm/>}/>
                    <Route path="/apploginsuccess" element={<AppLoginSuccess/>}/>
                    <Route path="/verification-success" element={<VerificationSuccess/>}/>
                    <Route path="/verification-needed" element={<EmailVerificationNeeded/>}/>

                    {/* Protected routes - require authentication */}
                    <Route element={<ProtectedRoute redirectPath="/signin" />}>
                        <Route path="/account" element={<AccountDetails userId={null} />}/>
                        <Route path="/admin/llm-models" element={<LLMModelManagement />}/>
                        <Route element={<ProtectedRoute redirectPath="/signin" requiredRole="developer" forbiddenRedirectPath="/account" />}>
                            <Route path="/api-keys" element={<ApiKeysManagement />}/>
                            <Route path="/proxy-example" element={<ProxyExample baseProxyEndpoint="/api/proxy/openai" />}/>
                        </Route>
                        {/* Add more protected routes here as needed */}
                    </Route>
                    
                    {/* Fallback route */}
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Route>
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>
        </AuthProvider>
    );
};

const rootElement = document.getElementById("app");

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <Provider>
            {/* <PostHogProvider apiKey={postHogAPIKey} options={options}></PostHogProvider> */}
            <Router>
                <App />
            </Router>
        </Provider>
    );
}
